<template>
  <div
    v-if="isExternal"
    :style="styleExternalIcon"
    class="svg-external-icon svg-icon"
    v-on="$listeners"
  />
  <svg
    v-else
    :style="styleSvgIcon"
    :class="svgClass"
    aria-hidden="true"
    v-on="$listeners"
  >
    <use :href="iconName" />
  </svg>
</template>

<script>
// doc: https://panjiachen.github.io/vue-element-admin-site/feature/component/svg-icon.html#usage
import { isExternal } from '@/utils/validate'

export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  computed: {
    nameOfIcon() {
      return this.name || this.iconClass
    },
    isExternal() {
      return isExternal(this.nameOfIcon)
    },
    iconName() {
      return `#icon-${this.nameOfIcon}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
    styleExternalIcon() {
      return {
        mask: `url(${this.nameOfIcon}) no-repeat 50% 50%`,
        '-webkit-mask': `url(${this.nameOfIcon}) no-repeat 50% 50%`,
      }
    },
    styleSvgIcon() {
      const style = {
        color: this.color,
      }

      if (this.size) {
        style.width = this.size
        style.height = this.size
      }

      if (this.width) {
        style.width = this.width
      }

      if (this.height) {
        style.height = this.height
      }

      return style
    },
  },
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  overflow: hidden;
  vertical-align: -0.15em;
  fill: currentColor;
}

.svg-external-icon {
  display: inline-block;
  background-color: currentColor;
  mask-size: cover !important;
}
</style>
